import { withTouchpointsApiActions } from './apiActionHelper';

export function getDashboardSSO(shopId, id, type) {
  return withTouchpointsApiActions((api) => {
    switch (type) {
      case 'explore':
        return api.getExplore(shopId, id);
      case 'look':
        return api.getLook(shopId, id);
      case 'dashboard':
      default:
        return api.getDashboard(shopId, id);
    }
  }, 'LOOKER_DASHBOARD');
}
